<button type="button" class="btn btn-link" (click)="select()">
  <ng-content></ng-content>
</button>
<input #file
       type="file"
       multiple
       [accept]="contentTypes.join(', ')"
       (change)="fileSelected()">
